import { render, staticRenderFns } from "./FaqCategoryEdit.vue?vue&type=template&id=3e798ce0&scoped=true"
import script from "./FaqCategoryEdit.vue?vue&type=script&lang=js"
export * from "./FaqCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e798ce0",
  null
  
)

export default component.exports